import { useState, useEffect } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import s from './LegalPage.module.css';

// fallback: MDファイルから静的インポート
import termsFallback from '../legal/terms.md?raw';
import privacyFallback from '../legal/privacy.md?raw';
import tokushohoFallback from '../legal/tokushoho.md?raw';

const FALLBACK: Record<string, string> = {
  terms: termsFallback,
  privacy: privacyFallback,
  tokushoho: tokushohoFallback,
};

function mdToHtml(md: string): string {
  return md
    .replace(/^\|(.+)\|$/gm, (_, row) => {
      const cells = row.split('|').map((c: string) => c.trim());
      if (/^-+$/.test(cells[0])) return '';
      const tag = cells.every((c: string) => /^\*\*.*\*\*$/.test(c)) ? 'th' : 'td';
      return '<tr>' + cells.map((c: string) => `<${tag}>${c.replace(/\*\*/g, '')}</${tag}>`).join('') + '</tr>';
    })
    .replace(/(<tr>.*<\/tr>\n?)+/g, (block) => `<table>${block}</table>`)
    .replace(/^### (.+)$/gm, '<h3>$1</h3>')
    .replace(/^## (.+)$/gm, '<h2>$1</h2>')
    .replace(/^# (.+)$/gm, '<h1>$1</h1>')
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
    .replace(/^(\d+)\. (.+)$/gm, '<li>$2</li>')
    .replace(/^- (.+)$/gm, '<li>$1</li>')
    .replace(/(<li>.*<\/li>\n?)+/g, (block) => `<ol>${block}</ol>`)
    .replace(/^---$/gm, '<hr />')
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/^(?!<[a-z])((?!^\s*$).+)$/gm, '<p>$1</p>')
    .replace(/<p><\/p>/g, '')
    .replace(/\n{2,}/g, '\n');
}

export function LegalPage({ pageId }: { pageId: string }) {
  const [content, setContent] = useState(FALLBACK[pageId] ?? '');

  useEffect(() => {
    fetch(`/api/public/legal/${pageId}`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data?.content) setContent(data.content); })
      .catch(() => {});
  }, [pageId]);

  return (
    <>
      <Header />
      <div className={s.container}>
        <div className={s.content} dangerouslySetInnerHTML={{ __html: mdToHtml(content) }} />
        <a href="/" className={s.backLink}>{'\u2190'} {'\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8\u306B\u623B\u308B'}</a>
      </div>
      <Footer />
    </>
  );
}
